import { render } from "./layoutStockDefaultPdfConfiguration.vue?vue&type=template&id=4be6eba2"
import script from "./layoutStockDefaultPdfConfiguration.vue?vue&type=script&lang=js"
export * from "./layoutStockDefaultPdfConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__